import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { Card } from "../kit/Kit";
import { mxn, sel } from "./common";
import { useCopilotoFiltros } from "../../lib/copiloto";
import { fDia } from "../../lib/trading";

const INS = ["Reinvertir", "Liquidar", "Sin dato"];
const slug = (s) => s.replace(/[≤–]/g, "").replace(/\s+/g, "-").toLowerCase();

const Fila = ({ r }) => (
  <div className="grid grid-cols-2 gap-1 border-t border-[#F2F0EC] py-2 text-xs md:grid-cols-6" data-testid="cap-venc-fila">
    <span className="truncate font-medium">{r.nombre || "—"}</span>
    <span>{r.vencimiento}{r.vencido_sin_corte && <b className="ml-1 text-amber-700">vencido · sin corte nuevo</b>}</span>
    <span>{r.plazo} · {mxn(r.saldo)}</span>
    <span>{r.tasa ?? "—"}%{r.tasa_renovacion !== undefined && <> → {r.tasa_renovacion == null ? "Sin tabla vigente" : `${r.tasa_renovacion}%`}{r.cambio_pp ? <b className={r.cambio_pp < 0 ? "ml-1 text-rose-700" : "ml-1 text-emerald-700"}> ({r.cambio_pp > 0 ? "+" : ""}{r.cambio_pp.toFixed(2)} pp)</b> : null}</>}</span>
    <span className="truncate">{r.referenciador || "Sin referenciador"}{r.ejecutivo && ` · ${r.ejecutivo}`}</span>
    <span className="truncate text-[#5C5850]">{r.retencion || r.tabla_renovacion || ""}</span>
  </div>
);

const Celda = ({ c, tid }) => <td className="px-2 py-1.5 text-right" data-testid={tid}><b>{c.contratos}</b><span className="block text-[11px] text-[#5C5850]">{mxn(c.saldo)}</span></td>;

const Horizontes = ({ hs, como }) => (
  <Card title="Por horizonte e instrucción" testid="cap-venc-horizontes">
    <div className="overflow-x-auto">
      <table className="w-full min-w-[560px] text-xs">
        <thead><tr className="text-[#8C867A]"><th className="px-2 py-1 text-left font-medium">Instrucción</th>{hs.map((h) => <th key={h.bucket} className="px-2 py-1 text-right font-medium">{h.bucket}</th>)}</tr></thead>
        <tbody>
          {INS.map((i) => <tr key={i} className="border-t border-[#F2F0EC]"><td className="px-2 py-1.5">{i}</td>{hs.map((h) => <Celda key={h.bucket} c={h.por_instruccion[i]} tid={`cap-venc-h-${slug(h.bucket)}-${slug(i)}`} />)}</tr>)}
          <tr className="border-t border-[#111]"><td className="px-2 py-1.5 font-semibold">Total</td>{hs.map((h) => <Celda key={h.bucket} c={h} tid={`cap-venc-h-${slug(h.bucket)}`} />)}</tr>
          <tr className="text-[#5C5850]"><td className="px-2 py-1.5">Acumulado</td>{hs.map((h) => <Celda key={h.bucket} c={{ contratos: h.acum_contratos, saldo: h.acum_saldo }} tid={`cap-venc-h-${slug(h.bucket)}-acum`} />)}</tr>
        </tbody>
      </table>
    </div>
    <p className="mt-2 text-[11px] text-[#8C867A]">{como}</p>
  </Card>
);

export const CapVencimientos = () => {
  const [dias, setDias] = useState(60);
  useCopilotoFiltros("captacion_vencimientos", (p) => { if (p === null) setDias(60); else if (p.horizonte || p.dias) setDias(Number(p.dias || (p.horizonte === "hoy" ? 1 : p.horizonte)) || 60); }, { filtros: { dias }, vista: "Captación · Vencimientos" });
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/captacion/vencimientos", { params: { dias } }).then((r) => setD(r.data)); }, [dias]);
  if (!d) return null;
  return (
    <div className="space-y-4" data-testid="cap-vencimientos">
      <div className="flex flex-wrap items-center gap-3 text-sm">
        <span>Corte {fDia(d.corte, true)} · lista hasta {fDia(d.hasta, true)}</span>
        <select value={dias} onChange={(e) => setDias(Number(e.target.value))} className={`${sel} w-auto`} data-testid="cap-venc-dias">{[30, 60, 90, 180, 365].map((x) => <option key={x} value={x}>{x} días</option>)}</select>
        <span className="text-xs text-[#8C867A]">{d.nota}</span>
      </div>
      {d.horizontes && <Horizontes hs={d.horizontes} como={d.horizontes_como} />}
      {Object.entries(d.grupos).map(([g, rows]) => (
        <Card key={g} title={`${g === "Reinvertir" ? "Reinvertir · nueva tasa a la renovación" : g === "Liquidar" ? "Liquidar · oportunidad de retención" : "Sin instrucción"} (${d.totales[g].contratos} · ${mxn(d.totales[g].saldo)})`} testid={`cap-venc-${g.replace(" ", "-").toLowerCase()}`}>
          {rows.length ? rows.map((r) => <Fila key={r.contrato} r={r} />) : <p className="text-xs text-[#8C867A]">Sin vencimientos en la ventana</p>}
        </Card>))}
    </div>
  );
};
